import { contactsSliceActions } from "./features/contacts";

export const GROUP_SLICES = [contactsSliceActions];
